"use client";

import React, {useEffect} from "react";
import {SDialogFC, SDialogProps} from "@/Master/SDialogFC/SDialogFC";
import {useDialogMethods} from "@/Master/SDialogFC/useDialogMethods";
import styles from "./TestMode.module.css";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import {NetworkDialogFC} from "@/app/_dialogs/NetworkDialog/NetworkDialog";
import {ShortcutDialogFC} from "@/app/_dialogs/ShortcutDialog/ShortcutDialog";
import {FirstChargeGiftPackDialogFC} from "@/app/_dialogs/FirstChargeGiftPackDialog/FirstChargeGiftPackDialog";
import {RewardDialogFC} from "@/app/_dialogs/RewardDialog/RewardDialog";
import {NewcomerGiftPackDialogFC} from "@/app/_dialogs/NewcomerGiftPackDialog/NewcomerGiftPackDialog";
import {SpecialGiftPackDialogFC} from "@/app/_dialogs/SpecialGiftPackDialog/SpecialGiftPackDialog";
import {SettingsDialogFC} from "@/app/_dialogs/SettingsDialog/SettingsDialog";
import {PaySelectionDialogFC} from "@/app/_dialogs/PaySelectionDialog/PaySelectionDialogFC";
import {VisitorRechargeDialogFC} from "@/app/_dialogs/VisitorRechargeDialog/VisitorRechargeDialog";

export interface TestModeDialogProps extends SDialogProps {

}

export const TestModeDialogFC: React.FC<TestModeDialogProps> = (props) => {
    const {fcKey, onClose} = props;

    const {closeDialog} = useDialogMethods(fcKey);

    useEffect(() => {
        console.log("NetworkDialog initialized");
        return () => {
            console.log("NetworkDialog disposed");
        };
    }, []);

    return (
        <SDialogFC
            fcKey={fcKey}
            mode="Full"
            title='Test Mode Dialog'
            isFullCloseBtn={true}
        >
            <div className={styles.testTop}>
                <div className={styles.testBox}>
                    <div className={styles.testHeader}>Test Mode Dialog</div>
                    <button className={`btn ${styles.btn} ${styles.grid}`} onClick={() => {
                        SDialogManagerFC.openDialog(NetworkDialogFC)
                    }}>NetworkDialog
                    </button>
                    <button className={`btn ${styles.btn} ${styles.grid}`} onClick={() => {
                        SDialogManagerFC.openDialog(ShortcutDialogFC)
                    }}>ShortcutDialog
                    </button>

                    <button className={`btn ${styles.btn} ${styles.grid}`} onClick={() => {
                        SDialogManagerFC.openDialog(RewardDialogFC, {
                            fcKey: SDialogManagerFC.getFCKey(RewardDialogFC),
                            scCount: 1551150.5150,
                            gcCount: 1005646641155,
                        })
                    }}>RewardDialog
                    </button>

                    <button className={`btn ${styles.btn} ${styles.grid}`} onClick={() => {
                        SDialogManagerFC.openDialog(NewcomerGiftPackDialogFC)
                    }}>NewcomerGiftPackDialog
                    </button>

                    <button className={`btn ${styles.btn} ${styles.grid}`} onClick={() => {
                        SDialogManagerFC.openDialog(SettingsDialogFC)
                    }}>SettingsDialog
                    </button>
                    <button className={`btn ${styles.btn} ${styles.grid}`} onClick={() => {
                        SDialogManagerFC.openDialog(VisitorRechargeDialogFC)
                    }}>VisitorRechargeDialog
                    </button>
                </div>

                <div className={styles.testBox}>
                    <div className={styles.testHeader}>金币相关</div>
                    <button className={`btn ${styles.btn} ${styles.grid}`} onClick={() => {
                        SDialogManagerFC.openDialog(NetworkDialogFC)
                    }}>NetworkDialog
                    </button>
                </div>


            </div>


        </SDialogFC>
    );
};
